import React, { useEffect , useState} from 'react';
import Head from 'next/head';
import dynamic from "next/dynamic";
import Intro from '@/components/salespro/intro';
import styles from './index.module.scss';
import { useDispatch } from "react-redux";
import { setShowBanner } from '../../redux/actions/genericActions';
import SchemaLoader from '@/components/hoc/SchemaLoader';
import { SproBreadCrumbSchema, SproFaqSchema, SproProductSchema, SproSchema } from '@/constants/schema';
import page_data from '../../data/page_data';

const Fetcher = async () => {
  const page_details = page_data["salespro-app-for-retailers"]
  const data = {
    faqs: page_details.faqs ? page_details.faqs : [],
    meta_tag_data: page_details.meta_tag ? page_details.meta_tag : [],
  }
  return data
}

export async function getServerSideProps() {
  const faqs = await Fetcher()
  return {
    props: { pageName: 'salespro-app-for-retailers', ...faqs }
  }
}

interface Props {
  faqs: {
    title: string,
    answer: string,
    links: string,
    is_blog: boolean,
  }[]  
}

const Features = dynamic(()=> import("@/components/salespro/features"),
{loading: () => <p>Loading ...</p>,ssr:true }
);

const Steps = dynamic(()=> import("@/components/salespro/Steps"),
{loading: () => <p>Loading ...</p>,ssr:true }
);

const Playlist = dynamic(()=> import("@/components/salespro/playlist"),
{loading: () => <p>Loading ...</p>,ssr:true }
);

const Faq = dynamic(()=> import("../../components/common/Faq"),
  { loading: () => <p>Loading ...</p>,ssr:true }
);

const PartnerVideos = dynamic(()=> import("@/components/salespro/partnerVideos"),
{ loading: () => <p>Loading ...</p>,ssr:true }
);

const Partners = dynamic(()=> import("../../components/about-us/Partners"),
{ loading: () => <p>Loading ...</p>,ssr:true }
);

const Form = dynamic(()=> import("@/components/salespro/form"),
{ loading: () => <p>Loading ...</p>,ssr:true }
);

const SalesproWebpage = (props:any) =>{
  const dispatch:any = useDispatch();
  const [video,setVideo] = useState('intro');
  const [videoPlaying,setVideoPlaying] = useState(true);
  
  useEffect(() => {
    dispatch(setShowBanner(false))
    return () => {
      dispatch(setShowBanner(true))
    }
  }, [])
  
  return (
    <div className={styles.parent_container}>
      <Head>
        <title>{props.meta_tag_data.tag_title}</title>
        <meta name="description" content={props.meta_tag_data.tag_description}></meta>
        <meta property="og:title" content={props.meta_tag_data.tag_title}/>
        <meta property="og:description" content={props.meta_tag_data.tag_description}/>
        <SchemaLoader schema={SproBreadCrumbSchema}/>
        <SchemaLoader schema={SproSchema}/>
        <SchemaLoader schema={SproProductSchema}/>
        <SchemaLoader schema={SproFaqSchema} />
      </Head>
      <Intro video={video} setVideo={setVideo} videoPlaying={videoPlaying} setVideoPlaying={setVideoPlaying}/>
      <Features />
      <PartnerVideos video={video} setVideo={setVideo} videoPlaying={videoPlaying} setVideoPlaying={setVideoPlaying}/>
      <Steps />
      <Playlist video={video} setVideo={setVideo} videoPlaying={videoPlaying} setVideoPlaying={setVideoPlaying}/>
      <div className='odd-even-start-with-white'>
        <Faq title="Frequently Asked Questions" questions={props.faqs} className='faq-primary'/>
      </div>
      <Partners IsHeading={true}/>
      <Form />
    </div>
    )    
}

export default SalesproWebpage;